import Vue from 'vue';
import router from './router';
import store from './store';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import {Layout, Header, Sider, Content, Footer, Menu, Submenu,
MenuItem, Button, Row, Col, DatePicker, TimePicker, Icon, Table,
Spin, Form, FormItem, Input, InputNumber, Select, Option, CheckboxGroup,
Checkbox, RadioGroup, Radio, Page, Modal, Message, Upload, Switch, Avatar, Steps, Step, Tooltip, Drawer,} from 'view-design';
import 'view-design/dist/styles/iview.css';
import vuescroll from 'vuescroll';
import Loading from './components/Loading';
import echarts from 'echarts';
import Request from './assets/js/request';
import Api from './assets/js/interface';
import Utils from './assets/js/utils';
import App from './App.vue';

Vue.component('Layout', Layout);
Vue.component('Header', Header);
Vue.component('Sider', Sider);
Vue.component('Content', Content);
Vue.component('Footer', Footer);
Vue.component('Menu', Menu);
Vue.component('Submenu', Submenu);
Vue.component('MenuItem', MenuItem);
Vue.component('Button', Button);
Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.component('DatePicker', DatePicker);
Vue.component('TimePicker', TimePicker);
Vue.component('Icon', Icon);
Vue.component('Table', Table);
Vue.component('Spin', Spin);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('Input', Input);
Vue.component('InputNumber', InputNumber);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Checkbox', Checkbox);
Vue.component('RadioGroup', RadioGroup);
Vue.component('Radio', Radio);
Vue.component('Avatar', Avatar);
Vue.component('Page', Page);
Vue.component('Modal', Modal);
Vue.component('Message', Message);
Vue.component('Upload', Upload);
Vue.component('Switchs', Switch);
Vue.component('Steps', Steps);
Vue.component('Step', Step);
Vue.component('Tooltip', Tooltip);
Vue.component('Drawer', Drawer);


Vue.use(vuescroll);
Vue.use(Loading);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.prototype.$Modal = Modal;
Vue.prototype.$Message = Message;
Vue.prototype.$Spin = Spin;
Vue.prototype.$Api = Api;
Vue.prototype.$Rq = Request;
Vue.prototype.$Utils = Utils;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
